export default {
  title: '修改邮箱',
  submit: '确定',
  cencel: '取消',
  success: '修改邮箱成功,将跳转至登录页面',
  sendSuccess: '邮件发送成功',
  error: {
    0: '验证码已过期',
    1: '验证码不正确',
    2: '新邮箱地址不能跟旧邮箱地址相同',
    3: '邮箱格式不正确'
  },
  getCode: '获取验证码',
  newTip: `请输入您要绑定的邮箱地址，更换后您可以通过新的邮箱登录和找回密码。`,
  oldTip: `点击获取验证码我们将发送邮件到{0}的邮箱中。`,
  code: `请填写验证码`,
  reset: `重新获取`,
  showTip1: `您的验证码已发送到{0}邮箱中,请前往邮箱查看验证码`,
  showTip2: `您的验证码已发送到{0}邮箱中<a target='_blank' href='{1}'>点此进入</a>`

}
